import { render, staticRenderFns } from "./submission.vue?vue&type=template&id=3a22073e&scoped=true&"
import script from "./submission.vue?vue&type=script&lang=js&"
export * from "./submission.vue?vue&type=script&lang=js&"
import style0 from "./submission.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./submission.vue?vue&type=style&index=1&id=3a22073e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22073e",
  null
  
)

export default component.exports